module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.resize),
      expression: "resize"
    }],
    class: _vm.rootClass
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-763e4e50!./~/vue-loader/lib/selector.js?type=template&index=0!./src/HierarchicalEdgeBundling.vue
// module id = 139
// module chunks = 0